import React, { useState } from 'react';
import { connect } from 'react-redux';
import { History } from 'history';
import { Formik, FormikHelpers } from 'formik';
import cn from 'classnames';

import { IAppState } from 'src/store';
import { Input, View, Button, Text, Image, InputPassword } from 'src/components/common';

import './styles.scss';
import Form from 'src/components/common/Form';
import { validateField } from 'src/validations';
import { authActions } from 'src/redux/authRedux';
import { IMAGES } from 'src/appConfig/images';
import { TokenService } from 'src/services';

type FormValue = {
  email: string;
  password: string;
};

const INTIAL = { email: '', password: '' };

const Interview: React.FC<Props> = ({ history, isLoading, onSignIn, onExchangeToken }) => {
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const handleLogin = (values: FormValue, helpers: FormikHelpers<FormValue>) => {
    setIsSubmitting(true);

    const { email, password } = values;
    onSignIn({ username: email, password }, handleSuccess, handleError(helpers));
  };

  const handleSuccess = (response: { signInUserSession: { accessToken: { jwtToken: any } } }) => {
    const cognitoToken = response.signInUserSession?.accessToken?.jwtToken;
    onExchangeToken(
      { idToken: cognitoToken },
      res => {
        TokenService.setApiToken(res.token);
        setIsSubmitting(false);
      },
      error => {
        setIsSubmitting(false);
      },
    );

  };

  const handleError = (helpers: FormikHelpers<FormValue>) => (error: {
    code: string;
    name: string;
    message: string;
  }) => {
    setIsSubmitting(false);

    console.error(error);
    if (error.code === 'NotAuthorizedException') {
      helpers.setErrors({ email: ' ', password: 'Incorrect username or password.' });
    } else if (error.code === 'UserNotFoundException') {
      helpers.setErrors({ email: 'Username does not exist.', password: ' ' });
    } else {
      helpers.setErrors({ email: ' ', password: 'An error has occurred.' });
    }
  };

  const handleValidate = (values: FormValue) => {
    const errors: { email?: string; password?: string } = {};

    if (validateField('email', values.email)) errors.email = validateField('email', values.email);
    if (validateField('password', values.password)) errors.password = validateField('password', values.password);

    return errors;
  };

  return (
    <View className="ctn-signin">
      <Image src={IMAGES.background} className="ctn-signin__background" />
      <Image src={IMAGES.logoRalph} className="ctn-signin__logo" />
      <Text className={cn('mb-20')}>{'Welcome to Ralph Rosenberg Admin Dashboard'}</Text>

      <Formik initialValues={INTIAL} onSubmit={handleLogin} validate={handleValidate} i>
        {({ values, errors, touched, handleChange, handleSubmit, handleBlur }) => (
          <Form onSubmit={handleSubmit} autoComplete="off">
            <Input
              label="Username *"
              placeholder="Enter email"
              name="email"
              value={values.email}
              onChange={handleChange}
              onBlur={handleBlur}
              errorMessage={touched.email ? errors.email : ''}
              containerClassName="mb-16"
            />
            <InputPassword
              label="Password *"
              placeholder="Enter password"
              name="password"
              value={values.password}
              onChange={handleChange}
              onBlur={handleBlur}
              errorMessage={touched.password ? errors.password : ''}
              containerClassName="mb-24"
            />
            <Button type="submit" variant="secondary" isFull isLoading={isSubmitting}>
              Log in
            </Button>
          </Form>
        )}
      </Formik>
    </View>
  );
};

type Props = ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps & { history: History };

const mapStateToProps = (state: IAppState) => ({
  isLoading: state.common.isLoading,
});

const mapDispatchToProps = {
  onSignIn: authActions.signIn,
  onExchangeToken: authActions.exchangeToken,
};

export default connect(mapStateToProps, mapDispatchToProps)(Interview);
